import * as THREE from 'three';
import gsap from 'gsap';
import { invokeAfterDelay, mapRange } from './Common';
import { scene, group } from './Scene';
import { setMoveToCameraNull } from './Camera';
import {
    SetSignBoardLight,
    SetCoinInsertLight, SetButtonLight,
    SetBulbLight,
    SetPatternMachineLight,
    SetSirenLight,
    SetGaugeLight,
    SetSpotLight,
} from './Light';
import {
    PlayCameraAction, StopCameraAction,
    PlayAnimation, RewindAnimation, StopAnimation,
    PlayObjetAnimation, PlayStageAnimation,
    StopIdleAnimation, ReplayIdleAnimation,
    SetFrameAnimation,
    obj
} from './Animations';
import { SetStageRaycastList } from './Raycaster';
import { SetAudio, RemoveAudio } from './Audio';
import confetti from 'canvas-confetti';

//#region common
const timeScale = 1;
export let step = 0;

let onStepChangeCallback = null;

export const SetStepChangeListener = (callback) => {
    onStepChangeCallback = callback;
}

export const SetStep = (_num) => {
    step = _num;
    // console.log('current Step :', step);
    OnStepChange(step);
    if (onStepChangeCallback) onStepChangeCallback(step);
}

let tanA, tanB;

//!TEST
let powerUI;

const OnStepChange = (_step) => {
    SetStageRaycastList(scene, _step);
    switch (_step) {
        case 0:
            // * 0
            // - init
            StopCameraAction();

            ResetScenario();
            //coin reset
            SetNavigationState(0, 'active');

            break;
        case 1:
            // * 1 자판기에 도착
            // - 동전 숨김처리

            SetCoinInsertLight(false);
            invokeAfterDelay(() => {
                SetButtonLight(true);
                // - 카메라 0
                SetRandomObjet();
            }, .5);

            SetSignBoardLight(1);
            SetNavigationState(1, 'active');
            break;
        case 2:
            // * 2 자판기에서 랜덤으로 하나 추출
            invokeAfterDelay(() => {
                // - 카메라 1번
                StopCameraAction();
                PlayCameraAction(1, timeScale * 0.5);
            }, 1);
            invokeAfterDelay(() => {
                // - geo 0번 재생
                SetObjetVisible(0);
                PlayObjetAnimation(0, () => {
                    SetStep(3);
                }, timeScale * 0.5);
            }, 2.2);
            // - 자판기 버튼 라이트
            SetButtonLight(false);

            invokeAfterDelay(() => {
                selectedIndex === 1 ?
                    SetAudio('03_section_a_2.wav', true)
                    : SetAudio('03_section_a_1.wav', true);
            }, 2.03);

            SetNavigationState(1, 'complete');

            break;
        case 3:
            //* 3 전구

            if (selectedIndex === 1) {
                SetBulbLight(true);
                SetObjetVisible(2);
                PlayObjetAnimation(2, () => {
                    console.log('원뿔 아웃 !');
                    // StopCameraAction();
                    SetObjetVisible(-1);
                    SetBulbLight(false);
                    invokeAfterDelay(() => {
                        setMoveToCameraNull(scene,
                            { x: -0.39278078079223633, y: 0.3673482835292816, z: 1.0869736671447754 },
                            { x: -0.20507515966892242, y: 0.06635970622301102, z: 0.20730015635490417 },
                            2
                        );
                    }, 2);
                    invokeAfterDelay(() => {
                        SetStep(1);
                    }, 4);
                }, timeScale);
            }
            else {
                // - geo 1번 재생
                SetObjetVisible(1);
                PlayObjetAnimation(1, () => {
                    SetStep(4);
                }, timeScale);
                // - 전구에 라이트 추가
                SetBulbLight(true);

                SetSignBoardLight(2);
                SetNavigationState(2, 'active');
                ShowNavigationInfo();
            }
            // // - geo 1번 재생
            // SetObjetVisible(1);
            // PlayObjetAnimation(1, () => {
            //     SetStep(4);
            // }, timeScale);
            // // - 전구에 라이트 추가
            // SetBulbLight(true);
            break;
        case 4:
            // * 4 기차 -> 열기구에 도착
            // - geo 2,3번 재생
            SetObjetVisible(3);
            PlayObjetAnimation(3, () => {
                invokeAfterDelay(() => {
                    // - 카메라 2번
                    StopCameraAction();
                    PlayCameraAction(2, timeScale);
                    // - 기차 애니메이션 재생
                    PlayStageAnimation(3, null, timeScale);
                    SetNavigationState(2, 'complete');
                }, 1);
                invokeAfterDelay(() => {
                    PlayObjetAnimation(5, () => {
                        SetStep(5);
                    }, timeScale);
                    PlayObjetAnimation(6, null, timeScale);
                }, 1.5);

                invokeAfterDelay(() => {
                    SetSignBoardLight(3);
                    SetNavigationState(3, 'active');
                }, 7);
            }, timeScale);
            PlayObjetAnimation(4, null, timeScale);

            break;
        case 5:
            // * 5 열기구 날라감
            // - 카메라 3번
            invokeAfterDelay(() => {
                StopCameraAction();
                PlayCameraAction(3, timeScale);
            }, 1);
            // - geo 4번
            SetObjetVisible(4);
            PlayObjetAnimation(7, null, timeScale);
            // - 열기구 애니메이션 재생 33~38
            PlayStageAnimation(4, null, timeScale);
            invokeAfterDelay(() => {
                SetVisibleBalloonEventUI(true);
                HideNavigationInfo();
            }, 5.5);
            invokeAfterDelay(() => {
                SetStep(6);
            }, 6);

            break;
        case 6:
            // * 6 폭격
            // - 화면전환
            // - 카메라 4번
            StopCameraAction();
            PlayCameraAction(4, timeScale);
            SetVisibleCloud(true);
            RattleModelEffect();
            // StopCameraAction();

            //* 기차 되돌리기
            RewindAnimation([
                { index: 35, startFrame: 606, endFrame: 912 },
                { index: 37, startFrame: 606, endFrame: 912 },
                { index: 38, startFrame: 606, endFrame: 912 },
            ], () => {
                RewindAnimation([
                    { index: 35, startFrame: 251, endFrame: 508 },
                    { index: 37, startFrame: 251, endFrame: 508 },
                    { index: 38, startFrame: 251, endFrame: 508 },
                ], null, timeScale * 4);
            }, timeScale * 4);

            //* 열기구 문 다시 열기
            RewindAnimation({ index: 41, startFrame: 554, endFrame: 795 }, null, timeScale);

            SetAudio('04_sky_target.wav');

            SetSignBoardLight(4);
            SetNavigationState(4, 'active');
            ShowNavigationInfo();

            break;
        case 7:
            // * 7 폭격 후
            // - 카메라 5번
            StopCameraAction();
            PlayCameraAction(5, timeScale);
            SetVisibleBalloonEventUI(false);
            SetVisibleCloud(false);
            // - geo 5번 조건에 맞게 재생
            //성공
            ResetModelPos();
            PlayBombAnimation(bombState);

            RemoveAudio('04_sky_target.wav');
            break;
        case 8:
            // * 라인 따라서 이동
            StopCameraAction();
            PlayCameraAction(6, timeScale * 1.5);

            SetObjetVisible(9);
            PlayObjetAnimation(13, () => {
                SetObjetVisible(10);
                PlayObjetAnimation(14, () => {
                    SetStep(9);
                }, timeScale * 1.5);
                PlayObjetAnimation(15, null, timeScale * 1.5);
            }, timeScale * 1.5);
            PlayStageAnimation(6, null, timeScale * 1.5);
            StopIdleAnimation([

                { index: 79 },
                { index: 80 },
                { index: 81 },
                { index: 82 },
                { index: 83 },
                { index: 84 },
                { index: 85 },
            ]);

            invokeAfterDelay(() => {
                SetAudio('07_section_b.wav', true);
            }, 1.2167);

            // SetSignBoardLight(0);
            SetNavigationState(4, 'complete');
            invokeAfterDelay(() => {
                HideNavigationInfo();
            }, 10);

            break;
        case 9:
            // * 페인트 색칠 
            StopCameraAction();
            PlayCameraAction(7, timeScale);

            SetObjetVisible(11);
            PlayObjetAnimation(16, () => {
                SetStep(10);
            }, timeScale);

            //* 펌프, 레버
            invokeAfterDelay(() => {
                PlayAnimation({ index: 70, startFrame: 1862, endFrame: 1891 }, () => {
                    RewindAnimation({ index: 70, startFrame: 1862, endFrame: 1891 }, null, timeScale);
                }, timeScale);

                PlayAnimation([
                    { index: 71, startFrame: 0, endFrame: 20 }, { index: 72, startFrame: 0, endFrame: 20 }
                ], () => {
                    RewindAnimation([
                        { index: 71, startFrame: 0, endFrame: 20 }, { index: 72, startFrame: 0, endFrame: 20 }
                    ], null, timeScale);
                }, timeScale * 2);
                PlayAnimation([
                    { index: 73, startFrame: 0, endFrame: 20 }, { index: 74, startFrame: 0, endFrame: 20 }
                ], () => {
                    RewindAnimation([
                        { index: 73, startFrame: 0, endFrame: 20 }, { index: 74, startFrame: 0, endFrame: 20 }
                    ], null, timeScale);
                }, timeScale * 2);
                PlayAnimation([
                    { index: 75, startFrame: 0, endFrame: 20 }, { index: 76, startFrame: 0, endFrame: 20 }
                ], () => {
                    RewindAnimation([
                        { index: 75, startFrame: 0, endFrame: 20 }, { index: 76, startFrame: 0, endFrame: 20 }
                    ], null, timeScale);
                }, timeScale * 2);
                SetAudio('08_pump_hint.wav', true);

                SetSignBoardLight(5);
                SetNavigationState(5, 'active');
                ShowNavigationInfo();
            }, 1.5);
            break;
        case 10:
            //* 레버 조작

            break;
        case 11:
            // * 케이블 카 -> 패턴 기계
            StopCameraAction();
            PlayCameraAction(8, timeScale);

            SetObjetVisible(11);
            PlayObjetAnimation(17, () => {
                SetObjetVisible(12);
                PlayObjetAnimation(18, () => {
                    invokeAfterDelay(() => {
                        SetStep(12);
                    }, 1);
                }, timeScale);
                // PlayStageAnimation(8, null, timeScale, THREE.LoopRepeat);
                ReplayIdleAnimation([
                    { index: 79 },
                    { index: 80 },
                    { index: 81 },
                    { index: 82 },
                    { index: 83 },
                    { index: 84 },
                    { index: 85 },
                ])
            }, timeScale);
            PlayAnimation({ index: 77, startFrame: 1914, endFrame: 1965 }, null, timeScale);

            SetAudio('12_section_c.wav', true);

            SetNavigationState(5, 'complete');

            break;
        case 12:
            //* 레버 되감기
            RewindAnimation({ index: 70, startFrame: 1891, endFrame: 1914 });
            RewindAnimation({ index: 77, startFrame: 1914, endFrame: 1965 });

            //* 패턴 설정
            SetObjetVisible(13);
            PlayObjetAnimation(19, () => {
                SetStep(13);
            }, timeScale);
            PlayObjetAnimation(20, null, timeScale);

            SetSignBoardLight(6);
            SetNavigationState(6, 'active');
            break;
        case 13:
            //* 패턴기계 도착
            StopIdleAnimation([{ index: 90 }, { index: 91 }]);
            SetScreen(currentTextureIndex);
            // SetScreenPower(true);
            break;
        case 14:
            //* 패턴 후
            SetPatternToObjet();
            FlickingScreen();
            SetPatternMachineLight(true, objetColor);
            SetNavigationState(6, 'complete');

            HideNavigationInfo();

            invokeAfterDelay(() => {
                StopCameraAction();
                PlayCameraAction(9, timeScale);

                ReplayIdleAnimation([{ index: 90 }, { index: 91 }]);
                SetObjetVisible(14);
                PlayObjetAnimation(21, null, timeScale);
                invokeAfterDelay(() => {
                    SetPatternMachineLight(false, objetColor);
                    PlayAnimation({ index: 78 }, null, timeScale); // 패턴기계 펄럭

                    SetAudio('15_section_d.wav', true);
                    SetSignBoardLight(0);
                }, 3);
                PlayObjetAnimation(22, null, timeScale);

                invokeAfterDelay(() => {
                    SetStep(15);
                }, 5.4);

                //* 확인버튼 되감기
                RewindAnimation({ index: 87 })
            }, 1);
            break;
        case 15:
            // * 미끄럼틀
            tanA = group.getObjectByName('s10_bezier_curve_tanA');
            tanB = group.getObjectByName('s10_bezier_curve_tanB');

            StopCameraAction();
            PlayCameraAction(10, timeScale);
            SetSirenLight(true);
            invokeAfterDelay(() => {
                SetObjetVisible(15);
                PlayObjetAnimation(23, null, timeScale);
                PlayStageAnimation(10, null, timeScale);
                invokeAfterDelay(() => {
                    TweenSlideBlendShape(tanA, 0);
                }, 7.5);
                invokeAfterDelay(() => {
                    TweenSlideBlendShape(tanB, 0);
                }, 8);
                // invokeAfterDelay(() => {
                //     TweenSlideBlendShape(tanA, 1);
                //     TweenSlideBlendShape(tanB, 1);
                // }, 9);

                SetSignBoardLight(7);
                SetNavigationState(7, 'active');
            }, 2);

            invokeAfterDelay(() => {
                RewindAnimation({ index: 104, startFrame: 2722, endFrame: 2933 });
            }, 6);

            invokeAfterDelay(() => {
                SetStep(16);
            }, 13);

            invokeAfterDelay(() => {
                SetAudio('16_siren_loop.wav');
            }, 13.35);

            ShowNavigationInfo();

            break;
        case 16:
            // * 발사 대기

            break;
        case 17:
            // * 발사
            PlaySlideAnimation();
            break;
        case 18:
            StopCameraAction();
            PlayCameraAction(11, timeScale);
            // SetObjetVisible(19);
            // PlayObjetAnimation(25, () => {
            //     SetStep(17);
            // }, timeScale);
            SetObjetVisible(-1);
            ShowCompletionObjet();
            invokeAfterDelay(() => {
                SetStep(19);
            }, 2);

            SetSignBoardLight(0);
            SetNavigationState(7, 'complete');
            HideNavigationInfo();
            break;
        case 19:
            // SetObjetVisible(19);
            // PlayObjetAnimation(26, null, timeScale, THREE.LoopRepeat);
            SetSpotLight(true);
            PlayConfetti();
            invokeAfterDelay(() => {
                SetStep(20);
            }, 2);
            SetNavigationState(8, 'active');
            break;
        case 20:
            SetSpotLight(false);
            ComeCloseCompletionObjet();

            //* 미끄럼틀 되감기
            tanA = group.getObjectByName('s10_bezier_curve_tanA');
            tanB = group.getObjectByName('s10_bezier_curve_tanB');
            TweenSlideBlendShape(tanA, 1);
            TweenSlideBlendShape(tanB, 1);

            // 문 A 2750 - 2824
            PlayAnimation({ index: 104, startFrame: 2750, endFrame: 2824 }, null, timeScale);
            invokeAfterDelay(() => {
                RewindAnimation([
                    { index: 92, startFrame: 2722, endFrame: 2933 },
                    { index: 93, startFrame: 2722, endFrame: 2933 },
                    { index: 94, startFrame: 2722, endFrame: 2933 },
                    { index: 95, startFrame: 2722, endFrame: 2933 },
                    { index: 96, startFrame: 2722, endFrame: 2933 },
                    { index: 97, startFrame: 2722, endFrame: 2933 },
                    { index: 98, startFrame: 2722, endFrame: 2933 },
                    { index: 99, startFrame: 2722, endFrame: 2933 },
                    { index: 100, startFrame: 2722, endFrame: 2933 },
                    { index: 101, startFrame: 2722, endFrame: 2933 },
                    // { index: 104, startFrame: 2722, endFrame: 2933 }, //레그 A 문
                    { index: 105, startFrame: 2722, endFrame: 2933 },
                ], () => {
                    RewindAnimation({ index: 104, startFrame: 2750, endFrame: 2933 }, null, timeScale);
                }, timeScale);
            }, 1);

            //* 손 되감기
            PlayStageAnimation(11, null, timeScale);

            //* 패턴기계 전원끄기
            SetScreenPower(false);

            //* 전구 끄기
            SetBulbLight(false);

            invokeAfterDelay(() => {
                SetStep(21);
            }, 3);
            SetNavigationState(8, 'complete');

            break;
        case 21:
            //* NavBar about open
            break;
    }
}

let selectedIndex = 0;
//#endregion

//#region navigation
// Navigation state ref for Main2.jsx
let navigationStatesRef = null;

export const SetNavigationStateRef = (_ref) => {
    navigationStatesRef = _ref;
};

const SetNavigationState = (index, state) => {
    if (!navigationStatesRef?.current) return;
    for (var i = 0; i < navigationStatesRef.current.length; i++) {
        if (i < index) {
            navigationStatesRef.current[i] = 'complete';
        }
        else if (i === index) {
            navigationStatesRef.current[index] = state;
        }
        else {
            navigationStatesRef.current[i] = '';
        }
    }
};

export const ShowNavigationInfo = () => {
    const background = document.querySelector('.navigation_bg');
    const infoContainer = document.querySelector('.navigation_info-container');

    if (!background || !infoContainer) return;

    gsap.killTweensOf(background);
    gsap.killTweensOf(infoContainer);

    // gsap.to(navigation, {
    //     duration: 0.5,
    //     height: 300,
    //     ease: 'linear'
    // });
    gsap.to(background, {
        duration: 0.5,
        opacity: 1,
        ease: 'linear'
    });
    gsap.to(infoContainer, {
        duration: 0.5,
        opacity: 1,
        ease: 'linear'
    });
}

export const HideNavigationInfo = () => {
    const background = document.querySelector('.navigation_bg');
    const infoContainer = document.querySelector('.navigation_info-container');

    if (!background || !infoContainer) return;

    gsap.killTweensOf(background);
    gsap.killTweensOf(infoContainer);

    // gsap.to(navigation, {
    //     duration: 0.5,
    //     height: 160,
    //     ease: 'linear'
    // });
    gsap.to(background, {
        duration: 0.5,
        opacity: 0.5,
        ease: 'linear'
    });
    gsap.to(infoContainer, {
        duration: 0.5,
        opacity: 0,
        ease: 'linear'
    });
}

//#endregion

//#region tooltip
let coinDownCount = 0;
let isCoinHovered = false;
export const ShowTooltip = () => {
    const tooltip = document.querySelector('.tooltip');
    const language = document.querySelector('.nav-laguage-sel').innerHTML;

    if (!tooltip) return;
    isCoinHovered = false;

    tooltip.style.opacity = 1;
    tooltip.textContent = (() => {
        switch (coinDownCount) {
            case 0:
                return language === 'ENG' ? 'Insert coin.' : '동전을 넣어주세요.';
            case 1:
                return language === 'ENG' ? 'Try dragging it around.' : '동전을 드래그 해보세요.';
            case 2:
                return language === 'ENG' ? 'Hold it a bit longer… just in case.' : '조금 더 오래.. 잡아보세요.';
            case 3:
                return language === 'ENG' ? 'The coin seems to be whispering something...' : '동전이 뭔가 말하고 싶은 것 같아요.';
            case 4:
                return language === 'ENG' ? 'Still haven’t inserted it? 🙃' : '아직도 안 넣으셨어요? 🙃';
            case 5:
                return language === 'ENG' ? 'Okay, no more games. The arcade is waiting!' : '자, 장난은 그만! 오릭기 기다려요~';
            default:
                return language === 'ENG' ? '🎮 Pick up the coin and insert it into the machine!' : '🎮 동전을 집어, 오락기에 넣으세요!';
        }
    })();
    // console.log('coin hover count : ', coinDownCount);
}

export const HideTooltip = () => {
    const tooltip = document.querySelector('.tooltip');
    if (!tooltip) return;

    tooltip.style.opacity = 0;
    if (!isCoinHovered) {
        coinDownCount += 1;
        isCoinHovered = true;
    }
}

export const MoveTooltip = (e) => {
    const tooltip = document.querySelector('.tooltip');
    if (!tooltip) return;

    tooltip.style.top = `${e.clientY + 14}px`;
    tooltip.style.left = `${e.clientX + 14}px`;
}

export const ShowHomeUI = () => {
    const logoBox = document.querySelector('.home_logo-box');
    const infoBox = document.querySelector('.home_info-box');
    if (!logoBox || !infoBox) return;

    gsap.to(logoBox, {
        top: 156,
        width: 592,
        height: 100,
        duration: 0.3,
    });
    gsap.to(infoBox, {
        opacity: 1,
        duration: 0.3
    });
}
//#endregion

//#region S01 choice
const objetList = [
    'geo_ani01', // 0
    'geo_ani02', // 1
    'geo_ani02_out', // 2
    'geo_ani03_constraint', //3
    'geo_ani04', // 4
    'geo_ani05_a', // 5
    'geo_ani05_b', // 6
    'geo_ani05_c', // 7
    'geo_ani05_d', // 8
    'geo_ani05_goal', // 9
    'geo_ani06_shake', // 10
    'geo_ani07', // 11
    'geo_ani08', // 12
    'geo_ani09_transform', // 13
    'geo_ani09_transform001', // 14
    'geo_ani10', // 15
    'geo_ani11', // 16
    'geo_ani11_a', // 17
    'geo_ani11_b', // 18
    'geo_ani11_c', // 19
    'geo_ani11_d', // 20
    'geo_ani12', // 21
    'geo_ani05_out', // 22
    'objet' // 23
];

export const InitScenario = () => {
    objetColor = new THREE.Color(1, 1, 1);

    objetList.forEach(name => {
        const object = scene.getObjectByName(name);
        object.visible = false;
        object.children.forEach(child => {
            child.visible = false;
            child.material.color.set(objetColor);
            child.material.map = null;
        });
    })
    // const obj = scene.getObjectByName(objetList[0]).children[0];
    // obj.material.color.set(objetColor);
    SetNavigationState(0, 'active');
}

const GetObjet = (_selectedIndex) => {
    const selectedChildren = [];
    if (_selectedIndex < 0) return selectedChildren;
    objetList.forEach(name => {
        const object = scene.getObjectByName(name);
        if (object && object.children.length > _selectedIndex) {
            selectedChildren.push(object.children[_selectedIndex]);
        }
    });
    return selectedChildren;
};

let isConeSelected = false;
export const SetRandomObjet = () => {
    // InitGeometry();
    const percentages =
        isConeSelected ?
            [25, 0, 25, 25, 25] // 한번이라도 원뿔이 선택된 적 있으면, 확률 조정
            : [20, 20, 20, 20, 20] // 육면체, 원뿔, 원기둥, 다면체, 구 각 항목의 백분율 (총합 100)

    const getRandomIndexByPercentage = () => {
        const randomNum = Math.random() * 100; // 0~100 사이 난수
        let cumulative = 0;

        for (let i = 0; i < percentages.length; i++) {
            cumulative += percentages[i];
            if (randomNum < cumulative) {
                if (i === 1) isConeSelected = true;
                return i
            };
        }
        return percentages.length - 1; // fallback
    };

    // 사용 예
    selectedIndex = getRandomIndexByPercentage();
    // console.log(`선택된 항목: ${selectedIndex}`);

    objetList.forEach(name => {
        const object = scene.getObjectByName(name);
        object.visible = false;
        object.children.forEach(child => {
            child.visible = false;
        });
    })

    const selectedChildren = GetObjet(selectedIndex);
    selectedChildren.forEach(child => {
        child.visible = true;
        child.castShadow = true;
        // child.receiveShadow = true;
    });
};

export const SetObjetVisible = (_index) => {
    objetList.forEach(name => {
        const object = scene.getObjectByName(name);
        if (name === objetList[_index]) {
            object.visible = true;
        }
        else {
            object.visible = false;
        }
    })
}

//#endregion

//#region S04 balloon
let balloonRef = null, balloonDimRef = null, balloonCrosshairBgRef = null, balloonCrosshairRef = null;

// const handleBalloonUI = () => SetVisibleBalloonEventUI(false);

export let isVisibleBalloonUI = false;

export const SetBalloonRef = (_ballonRef, _balloonDimRef, _balloonCrosshairBgRef, _balloonCrosshairRef) => {
    balloonRef = _ballonRef;
    balloonDimRef = _balloonDimRef;
    balloonCrosshairBgRef = _balloonCrosshairBgRef;
    balloonCrosshairRef = _balloonCrosshairRef;
}

export const SetVisibleBalloonEventUI = (isVisible) => {
    if (!balloonRef || !balloonDimRef) return;
    console.log('Set Visible Balloon UI : ', isVisible);
    if (isVisible) {
        isVisibleBalloonUI = true;

        balloonRef.current.style.display = 'block';
        balloonRef.current.style.pointerEvents = 'none';
        console.log(balloonDimRef.current.style.transform);
        gsap.killTweensOf(balloonDimRef.current);
        gsap.to(balloonDimRef.current, {
            // opacity: 1,
            transform: 'translate(0%, -50%)',
            duration: 0.5,
            ease: 'power2-in',
            onComplete: () => {
                gsap.to(balloonDimRef.current, {
                    opacity: 0,
                    // transform: 'translateY(50%)',
                    duration: 0.5,
                    ease: 'power2-out',
                    delay: 1,
                    onComplete: () => {
                        gsap.to(balloonDimRef.current, {
                            transform: 'translate(0%, 50%)',
                            opacity: 1,
                            duration: 0
                        })
                    }
                });
                gsap.to(balloonCrosshairBgRef.current, {
                    opacity: 1,
                    duration: 0.5
                });
                gsap.to(balloonCrosshairRef.current, {
                    opacity: 1,
                    duration: 0.5
                });
            }
        })
    }
    else {
        isVisibleBalloonUI = false;

        balloonRef.current.style.display = 'block';
        balloonRef.current.style.pointerEvents = 'none';
        gsap.killTweensOf(balloonCrosshairBgRef.current);
        gsap.to(balloonCrosshairBgRef.current, {
            opacity: 0,
            duration: 0.5
        });
        gsap.killTweensOf(balloonCrosshairRef.current);
        gsap.to(balloonCrosshairRef.current, {
            opacity: 0,
            duration: 0.5
        });
    }

}

export const MoveCrosshair = (e) => {
    // if (!isVisibleBalloonUI) return;

    if (!balloonCrosshairBgRef || !balloonCrosshairRef) return;

    if (balloonCrosshairBgRef.current) {
        // balloonCrosshairBgRef.current.style.setProperty('--mouse-x', `${e.clientX}px`);
        // balloonCrosshairBgRef.current.style.setProperty('--mouse-y', `${e.clientY}px`);
    }
    if (balloonCrosshairRef.current) {
        balloonCrosshairRef.current.style.setProperty('--mouse-x', `${e.clientX}px`);
        balloonCrosshairRef.current.style.setProperty('--mouse-y', `${e.clientY}px`);
    }
}
//#endregion

//#region S05 Balloon Bomb
let cloudContainer = null;
let cloudImages = ["cloud_1.png", "cloud_2.png"];
let clouds = [];
let isCloudVisible = true;

export const SetCloudContainer = (_container) => {
    cloudContainer = _container.current;
};

const createCloud = () => {
    if (!cloudContainer || !isCloudVisible) return;

    const cloud = document.createElement("img");
    cloud.src = `${process.env.PUBLIC_URL}/data/img/cloud/${cloudImages[Math.floor(Math.random() * cloudImages.length)]}`;
    cloud.classList.add("cloud");
    cloud.style.display = "none";

    cloudContainer.appendChild(cloud);
    clouds.push(cloud);

    cloud.onload = () => {
        // console.log("이미지 로드 완료, height 값:", cloud.clientHeight);
        cloud.style.display = "block";
        cloud.style.position = "absolute";
        cloud.style.width = `${Math.random() * 30 + 20}vw`;
        cloud.style.height = 'auto';

        // console.log('top : ', cloud.style.top, 'height : ', cloud.style.height);
        cloud.style.opacity = Math.random() * 0.5 + 0.5;
        cloud.style.transform = `scaleX(${Math.random() > 0.5 ? 1 : -1}) rotate(${Math.random() > 0.5 ? 90 : 0}deg))`;
        cloud.style.left = `${Math.random() * 80 + 10}vw`;
        cloud.style.top = `-${cloud.clientHeight}px`;

        const duration = Math.random() * 5 + 10;
        gsap.to(cloud, {
            top: "100vh",
            duration: duration,
            ease: "linear",
            onComplete: () => {
                cloud.remove();
                clouds = clouds.filter(c => c !== cloud);
            }
        });
    };


    setTimeout(createCloud, Math.random() * 3000 + 1000);
};

const SetVisibleCloud = (isVisible) => {
    isCloudVisible = isVisible;
    if (isCloudVisible) {
        gsap.killTweensOf(cloudContainer);
        gsap.to(cloudContainer, {
            opacity: 1,
            duration: 1
        });
        createCloud();
    }
    else {
        gsap.killTweensOf(cloudContainer);
        gsap.to(cloudContainer, {
            opacity: 0,
            duration: 1,
            onComplete: () => {
                while (cloudContainer.firstChild) {
                    cloudContainer.removeChild(cloudContainer.firstChild);
                }
                clouds = [];
            }
        });
    }
}

let bombState = 0;

export const SetBombState = (_num) => {
    //0: 성공
    //1: 실패 - 왼쪽
    //2: 실패 - 오른쪽
    bombState = _num;
}

let bombPosition = new THREE.Vector3();

export const SetBombPosition = (_pos) => {
    bombPosition = _pos;
}

const PlayBombAnimation = (_bombState) => {
    switch (_bombState) {
        case 0:
            // 성공
            SetObjetVisible(9);
            PlayObjetAnimation(8, () => {
                SetStep(8);
            }, timeScale);
            SetAudio('06_drop_success.wav', true);
            // PlayStageAnimation(5, null, timeScale);
            break;
        case 1:
            // 실패 왼쪽
            SetObjetVisible(5);
            PlayObjetAnimation(9, () => {
                SetVisibleBalloonEventUI(true);
                invokeAfterDelay(() => {
                    SetStep(6);
                }, 1);
            }, timeScale);
            SetAudio('05_drop_fail.wav', true);
            break;
        case 2:
            // 실패 아래
            SetObjetVisible(6);
            PlayObjetAnimation(10, () => {
                SetVisibleBalloonEventUI(true);
                invokeAfterDelay(() => {
                    SetStep(6);
                }, 1);
            }, timeScale);
            SetAudio('05_drop_fail.wav', true);
            break;
        case 3:
            // 실패
            SetObjetVisible(7);
            PlayObjetAnimation(11, () => {
                SetVisibleBalloonEventUI(true);
                invokeAfterDelay(() => {
                    SetStep(6);
                }, 1);
            }, timeScale);
            SetAudio('05_drop_fail.wav', true);
            break;
        case 4:
            // 실패
            SetObjetVisible(8);
            PlayObjetAnimation(12, () => {
                SetVisibleBalloonEventUI(true);
                invokeAfterDelay(() => {
                    SetStep(6);
                }, 1);
            }, timeScale);
            SetAudio('05_drop_fail.wav', true);
            break;
        case 5:
            // 주변
            SetObjetVisible(-1);
            const objet = group.getObjectByName('objet')
            objet.visible = true;
            objet.scale.set(0.01, 0.01, 0.01);
            //todo 오브젝트를 x,z 값에 맞게 낙하
            objet.position.set(bombPosition.x, 2, bombPosition.z);
            gsap.to(objet.rotation, {
                x: '+=6.283', // 360도 회전
                z: '+=3.1415', // 반바퀴 추가 회전
                duration: 2,
                ease: 'none'
            });

            gsap.to(objet.position, {
                y: 0,
                duration: 2,
                // ease: 'power1.in',
                onComplete: () => {
                    SetVisibleBalloonEventUI(true);
                    invokeAfterDelay(() => {
                        SetStep(6);
                    }, 1);
                }
            });
            SetAudio('05_drop_fail.wav', true);
            break;
    }
}

const RattleModelEffect = () => {
    if (!isCloudVisible) return;
    const targetPos = new THREE.Vector3();

    targetPos.x = Math.random() * 0.0025 - 0.00125;
    targetPos.y = 0;
    targetPos.z = Math.random() * 0.0025 - 0.00125;

    const randomDuration = Math.random() * 0.1 + 0.1;

    gsap.to(group.position, {
        x: targetPos.x,
        z: targetPos.z,
        duration: randomDuration
    });
    //* 1초~6초
    setTimeout(RattleModelEffect, randomDuration * 1000);
}

const ResetModelPos = () => {
    gsap.killTweensOf(group.position);
    gsap.to(group.position, {
        x: 0,
        y: 0,
        z: 0,
        duration: 0.2
    });
}

//#endregion

//#region S07 Paint
let objetColor = new THREE.Color(1, 1, 1);

export const SetObjetColor = (_color) => {
    const selectedChildren = GetObjet(selectedIndex);
    selectedChildren.forEach(child => {
        if (!child.material) {
            console.warn(`⚠️ '${child.name}'에 material이 없습니다.`);
            return;
        }

        // child.material.dispose(); // 기존 재질 제거
        child.material.color.set(objetColor);
    });
};

export const PressColor = (_pressObject) => {
    if (_pressObject.name === 's07_red_pump' || _pressObject.name === 's07_red_cap') {
        // 🔴
        objetColor.r = Math.min(objetColor.r + 0.01, 1);
        objetColor.g = objetColor.g <= 0 ? 0 : Math.min(objetColor.g - 0.005, 1);
        objetColor.b = objetColor.b <= 0 ? 0 : Math.min(objetColor.b - 0.005, 1);
    }
    else if (_pressObject.name === 's07_green_pump' || _pressObject.name === 's07_green_cap') {
        // 🟢
        objetColor.g = Math.min(objetColor.g + 0.01, 1);
        objetColor.r = objetColor.r <= 0 ? 0 : Math.min(objetColor.r - 0.005, 1);
        objetColor.b = objetColor.b <= 0 ? 0 : Math.min(objetColor.b - 0.005, 1);
    }
    else if (_pressObject.name === 's07_blue_pump' || _pressObject.name === 's07_blue_cap') {
        // 🔵
        objetColor.b = Math.min(objetColor.b + 0.01, 1);
        objetColor.r = objetColor.r <= 0 ? 0 : Math.min(objetColor.r - 0.005, 1);
        objetColor.g = objetColor.g <= 0 ? 0 : Math.min(objetColor.g - 0.005, 1);
    }
    // console.log('color', objetColor);
    SetObjetColor(objetColor);
}

let sprayObject
export const SetVisibleSpray = (_object, _isOn) => {
    if (_object.name === 's07_red_pump' || _object.name === 's07_red_cap') {
        sprayObject = group.getObjectByName('s07_spray_red');
    }
    else if (_object.name === 's07_green_pump' || _object.name === 's07_green_cap') {
        sprayObject = group.getObjectByName('s07_spray_green');
    }
    else if (_object.name === 's07_blue_pump' || _object.name === 's07_blue_cap') {
        sprayObject = group.getObjectByName('s07_spray_blue');
    }
    if (sprayObject) {
        gsap.killTweensOf(sprayObject.material);
        gsap.to(sprayObject.material, {
            opacity: _isOn ? 0.25 : 0,
            duration: 0.2,
        });
    }
}

export const SetLever = (_delta) => {
    const value = Math.floor(THREE.MathUtils.clamp(mapRange(_delta, 0, 0.17, 1891, 1914), 1891, 1914));
    SetFrameAnimation({ index: 70, frame: value })
}

export const ControlLever = (_delta) => {
    const value = Math.floor(THREE.MathUtils.clamp(mapRange(_delta, 0, 0.17, 1891, 1914), 1891, 1914));
    if (value >= 1912) {
        PlayAnimation({ index: 70, startFrame: value, endFrame: 1914 });
        SetAudio('11_2_pull_lever.wav', true);
        SetStep(11);
    } else {
        RewindAnimation({ index: 70, startFrame: 1891, endFrame: 1914 });
    }
    RemoveAudio('11_1_pull_lever.wav');
}

//#endregion

//#region S09 Pattern
const SetScreenPower = (_isOn) => {
    const screen = scene.getObjectByName('s09_screen');
    if (!screen) {
        console.warn("⚠️ 's09_screen' 오브젝트를 찾을 수 없습니다.");
        return;
    }
    if (_isOn) {
        // screen.material.color = new THREE.Color().setHex(0x000000);
        gsap.to(screen.material, {
            color: new THREE.Color().setHex(0xffffff),
            duration: 1,
        });
    }
    else {
        const color = screen.material.color;
        gsap.to(color, {
            r: 0,           // 빨간색 → 검정색
            g: 0,           // 초록색 값 증가
            b: 0,           // 파란색 값 유지
            duration: 1,
            onUpdate: () => {
                screen.material.color.setRGB(color.r, color.g, color.b); // 반드시 업데이트 필요
            }
        });
    }
}

let currentTextureIndex = 0;

const SetScreen = (_index) => {
    console.log(`🔢 ${_index}번 텍스쳐가 선택됐습니다.`)
    const screen = scene.getObjectByName('s09_screen');

    if (!screen) {
        console.warn("⚠️ 's09_screen' 오브젝트를 찾을 수 없습니다.");
        return;
    }

    const textureLoader = new THREE.TextureLoader();
    const texturePath = `${process.env.PUBLIC_URL}/data/textures/screen/${_index}.png`;

    textureLoader.load(texturePath, (texture) => {
        texture.flipY = false;
        texture.minFilter = THREE.LinearFilter;
        texture.magFilter = THREE.LinearFilter;
        texture.wrapS = THREE.ClampToEdgeWrapping;
        texture.wrapT = THREE.ClampToEdgeWrapping;
        texture.needsUpdate = true;

        // ✅ 텍스처 적용

        if (screen.material) {
            // 채널 전환 효과 (스크린 스케일 애니메이션)
            screen.material.map = texture;
            screen.material.color = new THREE.Color().setHex(0xffffff);
            screen.material.needsUpdate = true;
        } else {
            console.warn("⚠️ 's09_screen' 오브젝트에 material이 없습니다.");
        }
    }, undefined, (error) => {
        console.error("❌ 텍스처 로드 실패:", error);
    });
};

export const ChangePattern = (_direction) => {
    if (_direction === 'up') {
        currentTextureIndex++;
    }
    else if (_direction === 'down') {
        currentTextureIndex--;
    }
    if (currentTextureIndex < 0) currentTextureIndex = 6;
    if (currentTextureIndex > 6) currentTextureIndex = 0;
    SetScreen(currentTextureIndex);
}

export const FlickingScreen = () => {
    const screen = scene.getObjectByName('s09_screen');

    if (!screen) {
        console.warn("⚠️ 's09_screen' 오브젝트를 찾을 수 없습니다.");
        return;
    }

    const flickerEffect = (originalImage, callback) => {
        const canvas = document.createElement('canvas');
        canvas.width = originalImage.width;
        canvas.height = originalImage.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(originalImage, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
            const noise = Math.random() * 50 - 25;
            data[i] = 255 - data[i] + noise;
            data[i + 1] = 255 - data[i + 1] + noise;
            data[i + 2] = 255 - data[i + 2] + noise;
        }

        ctx.putImageData(imageData, 0, 0);
        const newTexture = new THREE.CanvasTexture(canvas);
        newTexture.needsUpdate = true;

        callback(newTexture);
    };

    if (screen.material) {
        const texture = screen.material.map.clone();
        flickerEffect(texture.image, (glitchedTexture) => {
            let flickCount = 0;
            const flickInterval = setInterval(() => {
                screen.material.map = flickCount % 2 === 0 ? texture : glitchedTexture;
                screen.material.needsUpdate = true;
                flickCount++;
                if (flickCount > 6) {
                    clearInterval(flickInterval);
                    screen.material.map = texture;
                    screen.material.color = new THREE.Color().setHex(0xffffff);
                    screen.material.needsUpdate = true;
                }
            }, 100);
        });
    } else {
        console.warn("⚠️ 's09_screen' 오브젝트에 material이 없습니다.");
    }
}

export const SetPatternToObjet = () => {
    const textureLoader = new THREE.TextureLoader();
    const texturePath = `${process.env.PUBLIC_URL}/data/textures/material/${currentTextureIndex}.png`;

    textureLoader.load(texturePath,
        (texture) => {
            texture.wrapS = THREE.ClampToEdgeWrapping;
            texture.wrapT = THREE.ClampToEdgeWrapping;
            texture.needsUpdate = true;

            const customMaterial = new THREE.MeshStandardMaterial({
                map: texture,
                color: objetColor,
            });

            customMaterial.onBeforeCompile = (shader) => {
                shader.fragmentShader = shader.fragmentShader.replace(
                    '#include <map_fragment>',
                    `
                    #ifdef USE_MAP
                        vec4 texColor = texture2D(map, vMapUv);
                        diffuseColor.rgb = mix(vec3(1.0) - diffuseColor.rgb, diffuseColor.rgb, texColor.r);
                    #endif
                    `
                );
            };
            customMaterial.needsUpdate = true;

            const applyMaterialSettings = (originalMaterial, newMaterial) => {
                if (originalMaterial.envMap) newMaterial.envMap = originalMaterial.envMap;
                if (originalMaterial.envMapIntensity !== undefined) newMaterial.envMapIntensity = originalMaterial.envMapIntensity;
                if (originalMaterial.metalness !== undefined) newMaterial.metalness = originalMaterial.metalness;
                if (originalMaterial.roughness !== undefined) newMaterial.roughness = originalMaterial.roughness;
                if (originalMaterial.color) newMaterial.baseColor = originalMaterial.color;
            };

            // 적용할 오브젝트 찾기
            const selectedChildren = GetObjet(selectedIndex);
            selectedChildren.forEach(child => {
                if (!child.material) {
                    console.warn(`⚠️ '${child.name}'에 material이 없습니다.`);
                    return;
                }

                const originalMaterial = child.material;
                applyMaterialSettings(originalMaterial, customMaterial);
                child.material = customMaterial;
                child.material.needsUpdate = true;
            });
            // console.log(selectedChildren[0].material);
        }, undefined, (error) => {
            console.error("❌ 텍스처 로드 실패:", error);
        });
}



//#endregion
//#region s10 Slide
/*
* 손
2722-2850 : 등장
2851-3083 : 발사
3084-3108 : 따봉
3150-3290 : 복귀
*/

// 성공시 : 따봉
// 실패시 : 되감기 밑 다시 공 생성

export const slideCurveValues = [0, 0];

const SetBlendShape = (obj, index, value) => {
    if (!obj || !obj.morphTargetInfluences || !obj.morphTargetDictionary) {
        console.warn(`⚠️ '${obj.name}'에서 블렌드 쉐이프를 찾을 수 없습니다.`);
        return;
    }
    obj.morphTargetInfluences[index] = THREE.MathUtils.clamp(value, 0, 1);
}

//* tan 0 이면 활성, slide는 1이면 활성
export const SetSlideBlendShape = (obj, value) => {
    const bezierBody = scene.getObjectByName("s10_bezier_body");
    const tanA = scene.getObjectByName('s10_bezier_curve_tanA');
    const tanB = scene.getObjectByName('s10_bezier_curve_tanB');

    if (obj.name === 's10_bezier_curve_tanA' || obj.name === 's10_hitbox2') {
        SetBlendShape(tanA, 0, value);
        SetBlendShape(bezierBody, 1, 1 - value);
    }
    else if (obj.name === 's10_bezier_curve_tanB' || obj.name === 's10_hitbox1') {
        SetBlendShape(tanB, 0, value);
        SetBlendShape(bezierBody, 0, 1 - value);
    }
}

const TweenBlendShape = (obj, index, value) => {
    if (!obj || !obj.morphTargetInfluences || !obj.morphTargetDictionary) {
        console.warn(`⚠️ '${obj.name}'에서 블렌드 쉐이프를 찾을 수 없습니다.`);
        return;
    }
    gsap.to(obj.morphTargetInfluences, {
        [index]: THREE.MathUtils.clamp(value, 0, 1),
        duration: 0.5,
        ease: "power2.out",
    });

    // console.log(`🎭 '${obj.name}' 블렌드 쉐이프 설정:`, value);
};

export const TweenSlideBlendShape = (obj, value) => {
    const bezierBody = scene.getObjectByName("s10_bezier_body");
    const tanA = scene.getObjectByName('s10_bezier_curve_tanA');
    const tanB = scene.getObjectByName('s10_bezier_curve_tanB');
    if (obj.name === 's10_bezier_curve_tanA' || obj.name === 's10_hitbox2') {
        if (value < 0.5) {
            TweenBlendShape(tanA, 0, 0);
            TweenBlendShape(bezierBody, 1, 1);
            PlayAnimation({ index: 159 });
            slideCurveValues[0] = 1;
        } else {
            TweenBlendShape(tanA, 0, 1);
            TweenBlendShape(bezierBody, 1, 0);
            slideCurveValues[0] = 0;
            RewindAnimation({ index: 159 });
        }
    }
    else if (obj.name === 's10_bezier_curve_tanB' || obj.name === 's10_hitbox1') {
        if (value < 0.5) {
            TweenBlendShape(tanB, 0, 0);
            TweenBlendShape(bezierBody, 0, 1);
            PlayAnimation({ index: 158 });
            slideCurveValues[1] = 1;
        } else {
            TweenBlendShape(tanB, 0, 1);
            TweenBlendShape(bezierBody, 0, 0);
            RewindAnimation({ index: 158 });
            slideCurveValues[1] = 0;
        }
    }
    // console.log('slideCurveValues', slideCurveValues);
}

let power = 0;
export const SetHandPower = (_value) => {
    if (power !== Math.floor(_value / 30)) {
        if (0 < Math.floor(_value / 30) && Math.floor(_value / 30) <= 5) {
            SetAudio('18_power_gauge.wav', true);
        }
        power = Math.floor(_value / 30);
        SetGaugeLight(power);
    }

}

const PlaySlideAnimation = () => {
    // * 1, 1 성공
    if (slideCurveValues[0] === 1 && slideCurveValues[1] === 1) {
        if (power < 2)
            SlideAnimations(0);
        else if (2 <= power && power <= 4)
            SlideAnimations(1);
        else if (4 < power)
            SlideAnimations(2);
    }
    // * 1, 0 실패 화면 밖으로 날라감
    else if (slideCurveValues[0] === 1 && slideCurveValues[1] === 0) {
        if (power <= 2)
            SlideAnimations(1);
        else if (3 === power)
            SlideAnimations(2);
        else if (3 < power)
            SlideAnimations(3);
    }
    // * 0, 1 실패 약해서 처박힘
    else if (slideCurveValues[0] === 0 && slideCurveValues[1] === 1) {
        if (power < 4)
            SlideAnimations(0);
        else if (4 <= power)
            SlideAnimations(1);

    }
    // * 0, 0 실패 약간 쎄서 뒤로 넘어감
    else {
        if (power < 3)
            SlideAnimations(0);
        else if (3 === power)
            SlideAnimations(1);
        else if (3 < power)
            SlideAnimations(2);
    }
}

const SlideAnimations = (_idx) => {
    //* 약해서 처박힘
    PlayHand(3031, 3083);
    if (_idx === 0) {
        SetObjetVisible(20);
        PlayObjetAnimation(28, () => {
            RewindHand(3031, 3083);
            invokeAfterDelay(() => {
                SetHandPower(0);
                SetObjetVisible(16);
                PlayObjetAnimation(24, () => {
                    SetStep(16);
                }, timeScale);
                invokeAfterDelay(() => {
                    SetAudio('22_drop_reset.wav', true);
                }, 0.8333);
            }, 2);
        });
        invokeAfterDelay(() => {
            SetAudio('19_finger_flick_fail_short.wav', true);
        }, 0.533);
    }

    //* 성공
    else if (_idx === 1) {
        SetObjetVisible(17);
        PlayObjetAnimation(25, () => {
            invokeAfterDelay(() => {
                SetHandPower(0);
                PlayHand(3084, 3108);
                SetSirenLight(false);
                RemoveAudio('16_siren_loop.wav');
                invokeAfterDelay(() => {
                    SetStep(18);
                }, 1);
            }, 0.5);
        }, timeScale);
        invokeAfterDelay(() => {
            SetAudio('21_finger_flick_success.wav', true);
        }, 0.533);
    }
    //* 약간 쎄서 뒤로 넘어감
    else if (_idx === 2) {
        SetObjetVisible(18);
        PlayObjetAnimation(26, () => {
            RewindHand(3031, 3083);
            invokeAfterDelay(() => {
                SetHandPower(0);
                SetObjetVisible(16);
                PlayObjetAnimation(24, () => {
                    SetStep(16);
                }, timeScale);
                invokeAfterDelay(() => {
                    SetAudio('22_drop_reset.wav', true);
                }, 0.8333);
            }, 2);
        });
        invokeAfterDelay(() => {
            SetAudio('20_2_finger_flick_fail_long.wav', true);
        }, 0.533);
    }
    //* 쎄서 날라감
    else if (_idx === 3) {
        SetObjetVisible(19);
        PlayObjetAnimation(27, () => {
            RewindHand(3031, 3083);
            invokeAfterDelay(() => {
                SetHandPower(0);
                SetObjetVisible(16);
                PlayObjetAnimation(24, () => {
                    SetStep(16);
                }, timeScale);
                invokeAfterDelay(() => {
                    SetAudio('22_drop_reset.wav', true);
                }, 0.8333);
            }, 2);
        });
        invokeAfterDelay(() => {
            SetAudio('20_1_finger_flick_fail_long.wav', true);
        }, 0.533);
    }
}

const PlayHand = (_starFrame, _endFrame) => {
    for (var i = 106; i < 157; i++) {
        PlayAnimation({ index: i, startFrame: _starFrame, endFrame: _endFrame });
    }

}

const RewindHand = (_starFrame, _endFrame) => {
    for (var i = 106; i < 157; i++) {
        RewindAnimation({ index: i, startFrame: _starFrame, endFrame: _endFrame });
    }
}
//#endregion

//#region final
export const CloneObjet = (name) => {
    const original = group.getObjectByName(name);
    if (!original) {
        console.warn('⚠️ 타겟 오브젝트를 찾을 수 없습니다.');
        return null;
    }

    const clone = original.clone(true);
    clone.traverse(child => {
        if (child.isMesh && child.material) {
            child.material = child.material.clone(); // 재질도 복제
        }
    });
    return clone;
};

const ShowCompletionObjet = () => {
    const objet = group.getObjectByName('objet')
    objet.visible = true;
    objet.position.set(0, 0.23, 0);
    objet.scale.set(0.015, 0.015, 0.015);

    objet.rotation.set(
        0 * (Math.PI / 180),
        0 * (Math.PI / 180),
        0 * (Math.PI / 180)
    );
    gsap.killTweensOf(objet.position);
    gsap.to(objet.position, {
        // x: -0.025,
        y: 0.33,
        // z: 0.5,
        duration: 2,
        ease: 'power2.inOut'
    });
    gsap.killTweensOf(objet.rotation);
    gsap.to(objet.rotation, {
        x: -50 * (Math.PI / 180),
        y: -160 * (Math.PI / 180),
        z: 30 * (Math.PI / 180),
        duration: 2,
        ease: 'power2.inOut'
    });

    // gsap.to(final.rotation, {
    //     z: '+=6.283',
    //     x: '+=6.283',
    //     duration: 2,
    //     repeat: -1,
    //     ease: 'none'
    // });
}

const IdleCompletionObjet = () => {
    const objet = group.getObjectByName('objet')
    objet.visible = true;

    gsap.killTweensOf(objet.position);
    gsap.to(objet.position, {
        y: 0.4525,
        duration: 1,
        yoyo: true,
        repeat: -1,
        ease: 'linear'
    });
}

const ComeCloseCompletionObjet = () => {
    const objet = group.getObjectByName('objet')
    objet.visible = true;

    gsap.killTweensOf(objet.position);
    // 베지어 곡선 정의
    const start = new THREE.Vector3(0, 0.33, 0);
    const control = new THREE.Vector3(0, 0.25, 0.25);
    const end = new THREE.Vector3(-0.025, 0.45, 0.5);
    const curve = new THREE.QuadraticBezierCurve3(start, control, end);

    const duration = 3; // 초
    let t = { value: 0 };

    gsap.to(t, {
        value: 1,
        duration: duration,
        ease: "power2.inOut",
        onUpdate: () => {
            const point = curve.getPoint(t.value);
            objet.position.set(point.x, point.y, point.z);
        },
        onComplete: () => {
            IdleCompletionObjet();
        }
    });

    gsap.to(objet.scale, {
        x: 0.05,
        y: 0.05,
        z: 0.05,
        duration: duration,
        ease: "power2.inOut"
    });
}

export const PlayConfetti = () => {
    const count = 200;
    const colors = ['#ff3850', '#FFD700', '#00BFFF', '#32CD32', '#ffffff']; // 다양한 색상
    const defaults = {
        origin: { x: 0.5, y: 0.35 }, // 위쪽에서 시작
        colors: colors
    };

    function fire(particleRatio, opts) {
        confetti({
            ...defaults,
            ...opts,
            particleCount: Math.floor(count * particleRatio)
        });
    }

    fire(0.25, {
        spread: 26,
        startVelocity: 45,
        scalar: 1.2,
        ticks: 300,        // 오래 유지
        gravity: 0.8        // 천천히 아래로
    });
    fire(0.2, {
        spread: 60,
        startVelocity: 30,
        scalar: 1.1,
        ticks: 300,
        gravity: 0.8
    });
    fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 1.0,
        ticks: 300,
        gravity: 0.8
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.4,
        ticks: 300,
        gravity: 0.8
    });
    fire(0.1, {
        spread: 120,
        startVelocity: 35,
        scalar: 1.3,
        ticks: 300,
        gravity: 0.8
    });
};


export const ResetScenario = () => {
    const objet = group.getObjectByName('objet');

    gsap.killTweensOf(objet.position);
    gsap.killTweensOf(objet.rotation);

    gsap.to(objet.scale, {
        x: 0,
        y: 0,
        z: 0,
        duration: 0.5,
        ease: 'none',
        onComplete: () => {
            InitScenario();
        }
    });

    const coin = group.getObjectByName('start_coin');
    coin.visible = true;
    coin.position.set(-0.025, 0.45, 0.5);
    coin.rotation.set(-Math.PI / 2, Math.PI, 0);
    gsap.to(coin.rotation, {
        z: '+=6.283',
        duration: 2,
        repeat: -1,
        ease: 'none'
    });
    gsap.killTweensOf(coin.scale);
    gsap.to(coin.scale, {
        x: 0.05,
        y: 0.038,
        z: 0.05,
        duration: 0.5,
        delay: 0.5
        // ease: 'power2.inOut'
    });
    SetSignBoardLight(0);

    ShowHomeUI();
}
//#endregion

/* 
1. 랜덤으로 개체 선택
- 육면체, 삼각뿔, 원기둥, 다면체, 구
2. 열기구 인터랙션
- 실패, 성공 판단
3. 개체 색상 변경
- RGB 0~255 값 조절
4. 개체 패턴 변경
- 7개의 텍스쳐 적용시키기
5. 베지어 그래프 조작
- 오브젝트 블랜드 쉐입
- 4개의 분기에 따른 애니메이션 재생
6. 현재 진행도 파악?
- step.
*/